import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Auth from '../pages/auth';
import Login from '../pages/auth/Login';
import Validate2fa from '../pages/auth/Validate2fa';
import ForgotPassword from '../pages/auth/ForgotPassword';
import CheckMail from '../pages/auth/CheckMail';
import CreateNewPassword from '../pages/auth/CreateNewPassword';
import PasswordReset from '../pages/auth/PasswordReset';
import KYCInformation from '../pages/auth/KYCInformation';
import EmailsInformation from '../pages/auth/EmailsInformation';
import SettlementInformation from '../pages/auth/SettlementInformation';

import Dashboard from '../pages/dashboard';
import Home from '../pages/dashboard/Home';
import Transactions from '../pages/dashboard/Transactions';
import TransactionOverview from '../pages/dashboard/Transactions/TransactionOverview';
import Business from '../pages/dashboard/Business';
import BusinessDetails from '../pages/dashboard/Business/BusinessDetails';
import Settings from '../pages/dashboard/Settings';
import { getValues } from '../services/storage';
import {handleLogout} from '../utils';

const AppRouter = (props) => {   
  const auth_token = getValues('auth_token'); 
  const userAvailable = props.user_loggedIn && props.user_authData !== null;

  return (
    <Router>
        <Routes>
            <Route path='/' element={userAvailable ? <Navigate to='/dashboard'/> : <Navigate to='/auth'/>}/>
            <Route path='/auth' element={userAvailable ? <Navigate to='/dashboard'/> : <Navigate to='/auth/login'/>}/>
            <Route path='/auth' element={userAvailable ? <Navigate to='/dashboard'/> : <Auth/>}>
              <Route path='/auth/login' element={userAvailable ? <Navigate to='/dashboard'/> : <Login/>}/>
              <Route path='/auth/validate_2fa' element={userAvailable ? <Navigate to='/dashboard'/> : <Validate2fa/>}/>
              <Route path='/auth/check_mail' element={userAvailable ? <Navigate to='/dashboard'/> : <CheckMail/>}/>
              <Route path='/auth/forgot_password' element={userAvailable ? <Navigate to='/dashboard'/> : <ForgotPassword/>}/>
              <Route path='/auth/password_reset' element={userAvailable ? <Navigate to='/dashboard'/> : <PasswordReset/>}/> 
              <Route path='/auth/create_new_password' element={userAvailable ? <Navigate to='/dashboard'/> : <CreateNewPassword/>}/>
              <Route path='/auth/create_new_password/:id' element={userAvailable ? <Navigate to='/dashboard'/> : <CreateNewPassword/>}/>
              <Route path='/auth/kyc_info' element={userAvailable ? <Navigate to='/dashboard'/> : <KYCInformation/>}/>
              <Route path='/auth/emails_info' element={userAvailable ? <Navigate to='/dashboard'/> : <EmailsInformation/>}/>
              <Route path='/auth/settlement_info' element={userAvailable ? <Navigate to='/dashboard'q/> : <SettlementInformation/>}/>
            </Route>

            <Route path='/dashboard' element={userAvailable ? <Navigate to='/dashboard/home'/> : <Navigate to='/auth/login'/>}/>
            <Route path='/dashboard' element={userAvailable ? <Dashboard/> : <Navigate to='/auth/login'/>}>
              <Route path='/dashboard/home' element={userAvailable ? <Home/> : <Navigate to='/auth/login'/>}/>
              <Route path='/dashboard/transactions' element={userAvailable ? <Transactions/> : <Navigate to='/auth/login'/>}/>
              {/* <Route path='/dashboard/transactions/transaction_overview/:id' element={userAvailable ? <TransactionOverview/> : <Navigate to='/auth/login'/>}/> */}
              <Route path='/dashboard/businesses' element={userAvailable ? <Business/> : <Navigate to='/auth/login'/>}/>
              <Route path='/dashboard/businesses/business_details/:id' element={userAvailable ? <BusinessDetails/> : <Navigate to='/auth/login'/>}/>
              <Route path='/dashboard/settings' element={userAvailable ? <Settings/> : <Navigate to='/auth/login'/>}/>
            </Route>
        </Routes>
    </Router>
  )
}

const mapStateToProps = state => ({
  user_loggedIn: state.auth.user_loggedIn,
  user_authData: state.auth.user_authData
})

export default connect(mapStateToProps, null)(AppRouter)